<template>
  <!-- eslint-disable -->
  <div class="mobile-wrapper">
    <SideNavMobile />
    
    <div class="mobile-container">
      <div v-if="loaded" class="professionals-container">
        <!-- Compact Mobile Header -->
        <div class="mobile-header">
           <div class="header-top">
              <div class="page-icon-small" :style="iconStyle">
                <svg class="w-5 h-5 text-white" aria-hidden="true" xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
                  <path fill-rule="evenodd" d="M12.037 21.998a10.313 10.313 0 0 1-7.168-3.049 9.888 9.888 0 0 1-2.868-7.118 9.947 9.947 0 0 1 3.064-6.949A10.37 10.37 0 0 1 12.212 2h.176a9.935 9.935 0 0 1 6.614 2.564L16.457 6.88a6.187 6.187 0 0 0-4.131-1.566 6.9 6.9 0 0 0-4.794 1.913 6.618 6.618 0 0 0-2.045 4.657 6.608 6.608 0 0 0 1.882 4.723 6.891 6.891 0 0 0 4.725 2.07h.143c1.41.072 2.8-.354 3.917-1.2a5.77 5.77 0 0 0 2.172-3.41l.043-.117H12.22v-3.41h9.678c.075.617.109 1.238.1 1.859-.099 5.741-4.017 9.6-9.746 9.6l-.215-.002Z" clip-rule="evenodd" />
                </svg>
              </div>
              <h1 class="page-title-small">Analytics</h1>
           </div>
           <p class="page-subtitle-small">{{ prestador && prestador.nombre }}</p>
        </div>

        <!-- Dashboard Component -->
        <div class="dashboard-wrapper-mobile">
            <component :is="currentDashboard" v-if="hasDashboard" />
            <div v-else class="no-dashboard-message">
              <div class="empty-state-mobile">
                <div v-if="!prestadorId && prestador && (prestador.id === 1 || prestador.id === 23)">
                  <h3>Seleccione Dashboard</h3>
                  <div class="dashboard-selector-mobile">
                    <button v-for="(loader, pid) in dashboards" :key="pid" class="btn-dashboard-mobile"
                      @click="selectDashboard(pid)">
                      {{ getDashboardName(pid) }}
                    </button>
                  </div>
                </div>
                <div v-else>
                  <svg xmlns="http://www.w3.org/2000/svg" width="64" height="64" viewBox="0 0 24 24" fill="none"
                    stroke="#64748b" stroke-width="1.5">
                    <path d="M3 3h18v18H3zM21 9H3m18 6H3m12-6V3m-6 6V3m-6 6v12m6-6v6m6-6v6" />
                  </svg>
                  <h3>Característica en Desarrollo</h3>
                  <p>Nos encontramos en desarrollo de reportería potenciada con Google Analytics para conocer el recorrido
                    de los clientes.</p>
                </div>
              </div>
            </div>
        </div>
      </div>
      <div v-else class="loading-container">
         <Loader :height="50" :width="50" />
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex';
import Loader from '@/components/Loader.vue';
import SideNavMobile from '@/components/SideNavMobile.vue';

export default {
  name: 'GoogleAnalyticsMobile',
  props: {
    prestadorId: {
      type: Number,
      required: false,
      default: null
    }
  },
  components: {
    Loader,
    SideNavMobile
  },
  data() {
    return {
      loaded: false,
      hasDashboard: false,
      currentDashboard: null,
      dashboards: {
        3: () => import('@/components/dashboardsGoogle/Dashboard_3.vue'),
        5: () => import('@/components/dashboardsGoogle/Dashboard_5.vue'),
        9: () => import('@/components/dashboardsGoogle/Dashboard_9.vue'),
        13: () => import('@/components/dashboardsGoogle/Dashboard_13.vue'),
        14: () => import('@/components/dashboardsGoogle/Dashboard_14.vue'),
        15: () => import('@/components/dashboardsGoogle/Dashboard_15.vue'),
        18: () => import('@/components/dashboardsGoogle/Dashboard_18.vue'),
      }
    }
  },
  computed: {
    ...mapGetters(['prestador']),
    iconStyle() {
      return {
        backgroundImage: `linear-gradient(139deg, ${this.prestador?.admin?.assets?.colors?.primary || '#3b82f6'} 0%, ${this.prestador?.admin?.assets?.colors?.secondary || '#6366f1'} 100%)`
      }
    }
  },
  async mounted() {
    await this.loadDashboard();
  },
  methods: {
    async loadDashboard(forcedId = null) {
      this.loaded = false;
      try {
        const pid = forcedId || this.prestadorId || Number(this.prestador?.id);

        if (pid && this.dashboards[pid]) {
          const component = await this.dashboards[pid]();
          this.currentDashboard = component.default;
          this.hasDashboard = true;
        } else {
          this.hasDashboard = false;
        }
      } catch (error) {
        console.error('Error cargando el dashboard:', error);
        this.hasDashboard = false;
      } finally {
        this.loaded = true;
      }
    },
    checkForDashboard() {
      this.loadDashboard();
    },
    getDashboardName(pid) {
      const names = {
        3: 'Bionet',
        5: 'Alemana',
        9: 'Integramedica',
        13: 'LB',
        14: 'UC Christus',
        15: 'Davila',
        18: 'SportsMD'
      };
      return names[pid] || `Prestador ${pid}`;
    },
    selectDashboard(pid) {
      // Navegar a la ruta con el ID seleccionado
      this.$router.push({ name: 'GoogleAnalyticsById', params: { id: pid } });
    }
  },
  watch: {
    '$route.params.id': {
      immediate: true,
      handler(newId) {
        this.loadDashboard(newId); 
      }
    }
  },
}
</script>


<style scoped>
.mobile-wrapper {
  width: 100%;
  min-height: 100vh;
  background: #f8fafc;
  padding-top: 60px; /* Space for fixed mobile top nav if exists, currently TopNavClean isn't used here so maybe just 20px */
}

.mobile-container {
  padding: 10px;
}

.mobile-header {
  background: white;
  padding: 15px;
  border-radius: 12px;
  box-shadow: 0 1px 3px rgba(0,0,0,0.05);
  margin-bottom: 15px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.header-top {
    display: flex;
    align-items: center;
    gap: 10px;
}

.page-icon-small {
  width: 32px;
  height: 32px;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  color: white;
}

.page-title-small {
  font-size: 1.1rem;
  font-weight: 700;
  color: #1e293b;
  margin: 0;
}

.page-subtitle-small {
  font-size: 0.85rem;
  color: #64748b;
  margin: 0;
}

.dashboard-wrapper-mobile {
    overflow-x: auto;
    -webkit-overflow-scrolling: touch;
    width: 100%;
    padding-bottom: 20px; /* Space for scrollbar */
}

.dashboard-wrapper-mobile >>> .dashboard-container {
    height: calc(100vh - 180px) !important; /* Adjusted slightly to fit */
    border: none !important;
    box-shadow: none !important;
    border-radius: 8px !important;
    min-width: 1200px; /* Force minimum width to prevent pixelation */
}

.dashboard-wrapper-mobile >>> iframe {
    border-radius: 8px;
    height: 100%;
}

.dashboard-selector-mobile {
    display: grid;
    grid-template-columns: repeat(2, 1fr);
    gap: 8px;
    margin-top: 15px;
}

.btn-dashboard-mobile {
    padding: 10px;
    border: 1px solid #e2e8f0;
    border-radius: 8px;
    background: white;
    font-size: 0.9rem;
    color: #475569;
}

.empty-state-mobile {
    text-align: center;
    padding: 20px;
    background: white;
    border-radius: 12px;
}

/* Keep existing loading-container and no-dashboard-message styles, but adjust for mobile context if needed */
.professionals-container {
  min-height: 100vh;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'Roboto', sans-serif;
}

.loading-container {
  display: flex;
  align-items: center;
  justify-content: center;
  min-height: 60vh;
}

.loading-content {
  text-align: center;
  max-width: 400px;
}

.loading-content h3 {
  font-size: 1.5rem;
  font-weight: 600;
  color: #1e293b;
  margin: 1rem 0 0.5rem;
}

.loading-content p {
  color: #64748b;
  margin: 0;
  line-height: 1.6;
}

/* Estilos para el mensaje de no dashboard */
.no-dashboard-message {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 60vh;
}
</style>